import Sticky from "@/components/Sticky";
import { useIsMobileView } from "@/contexts/ResponsiveProvider";
import { useIntersect } from "@/hooks/useIntersect";
import { useCallback, useEffect, useRef, useState } from "react";

const useFooter = () => {
  const footer = useRef<HTMLElement | null>(null);
  useEffect(() => {
    const element = document.getElementsByTagName("footer")[0];
    if (!element) return;
    footer.current = element;
  }, []);
  return footer;
};

export default function StickyUptoFooter({
  children,
  offset = 0,
  className = "",
}: {
  children: React.ReactNode;
  offset?: number; // 상단에서 얼마나 떨어진 지점에 도달했는지 확인
  className?: string;
}) {
  const footer = useFooter();
  const isMobile = useIsMobileView();
  const [cloneable, setCloneable] = useState(true);

  const onIntersect = useCallback(
    ([entry]: IntersectionObserverEntry[]) => {
      if (!isMobile) {
        setCloneable(true);
        return;
      }

      if (entry) {
        setCloneable(!entry.isIntersecting);
      }
    },
    [isMobile],
  );

  useIntersect(footer, onIntersect);

  return (
    <Sticky offset={offset} className={className} cloneable={cloneable}>
      {children}
    </Sticky>
  );
}
